import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePrzewodnik from "../pages/article/kakobuy-spreadsheet-przewodnik/page";
import ArticleCoToJest from "../pages/article/kakobuy-spreadsheet-co-to-jest/page";
import ArticleJakKorzystac from "../pages/article/jak-korzystac-z-kakobuy-spreadsheet/page";
import ArticleNajlepszy2026 from "../pages/article/najlepszy-kakobuy-spreadsheet-2026/page";
import ArticlePolska from "../pages/article/kakobuy-spreadsheet-polska/page";
import ArticleBezpieczny from "../pages/article/czy-kakobuy-jest-bezpieczny/page";
import ArticleVsAllChina from "../pages/article/kakobuy-vs-allchinabuy/page";
import ArticleVsOrientdig from "../pages/article/kakobuy-vs-orientdig/page";
import ArticleVsSuperbuy from "../pages/article/kakobuy-vs-superbuy/page";
import ArticleNajlepszyAgent from "../pages/article/najlepszy-agent-zakupowy-polska/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artykul/kakobuy-spreadsheet-przewodnik",
    element: <ArticlePrzewodnik />,
  },
  {
    path: "/artykul/kakobuy-spreadsheet-co-to-jest",
    element: <ArticleCoToJest />,
  },
  {
    path: "/artykul/jak-korzystac-z-kakobuy-spreadsheet",
    element: <ArticleJakKorzystac />,
  },
  {
    path: "/artykul/najlepszy-kakobuy-spreadsheet-2026",
    element: <ArticleNajlepszy2026 />,
  },
  {
    path: "/artykul/kakobuy-spreadsheet-polska",
    element: <ArticlePolska />,
  },
  {
    path: "/artykul/czy-kakobuy-jest-bezpieczny",
    element: <ArticleBezpieczny />,
  },
  {
    path: "/artykul/kakobuy-vs-allchinabuy",
    element: <ArticleVsAllChina />,
  },
  {
    path: "/artykul/kakobuy-vs-orientdig",
    element: <ArticleVsOrientdig />,
  },
  {
    path: "/artykul/kakobuy-vs-superbuy",
    element: <ArticleVsSuperbuy />,
  },
  {
    path: "/artykul/najlepszy-agent-zakupowy-polska",
    element: <ArticleNajlepszyAgent />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;